import React from 'react';
import { CheckboxField } from '@/components/ui/checkbox-field';

interface FilterCheckboxGroupProps {
  options: string[];
  selected: string[];
  onToggle: (value: string, checked: boolean) => void;
  /** Renders the raw value by default; used for capitalised file extensions. */
  formatLabel?: (value: string) => string;
}

const FilterCheckboxGroup: React.FC<FilterCheckboxGroupProps> = ({
  options,
  selected,
  onToggle,
  formatLabel,
}) => (
  <div className="flex flex-col gap-2.5">
    {options.map((option) => (
      <CheckboxField
        key={option}
        checked={selected.includes(option)}
        onChange={(checked) => onToggle(option, checked)}
        label={formatLabel ? formatLabel(option) : option}
      />
    ))}
  </div>
);

export default FilterCheckboxGroup;
